export enum AdminAnswersTableColumnDataIndex {
  OrdinalNumber = "ordinalNumber",
  Answer = "answer",
  Tip = "tip",
  Options = "options",
}
